import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';

import { CurrentUserService } from '../../user/services/current-user.service';
import { UserTypeEnum } from '../../user/models/user';

const forbiddenURLs = [
  'project',
  'monitoringtopic',
  'filtertree',
  'monitoringtopicsubscription',
  'issuesearchitem',
  'projecttag',
  'issue/calendar',
  'process',
  'task',
  'table',
  'tablecolumn',
  'report',
  'reportissue',
  'larisearch',
  'lariitem',
  'internallariitem',
  'externalsource',
  'filteredtable',
  'tablerow',
  'tableattribute',
  'company',
  'lariuser/current/counts/',
];

export const ticketingUserInterceptor: HttpInterceptorFn = (request, next) => {
  const currentUser = inject(CurrentUserService);

  let isTicketingUser = false;
  try {
    isTicketingUser = currentUser.user.user_type === UserTypeEnum.TICKETING;
  } catch {
    // runs on the login request too, before any user is known
  }

  if (isTicketingUser) {
    if (forbiddenURLs.some(url => request.url.startsWith(`/api/${url}`))) {
      return EMPTY;
    }
  }
  return next(request);
};
